import React, {Component} from 'react'
import {connect} from 'react-redux'
import ImportIndexMenuItem from "./ImportIndexMenuItem"
import ImportCreateButton from "./ImportCreateButton"

class ImportIndexMenu extends Component {
    render() {
        return (
            <div className="navbarAuthDiv" style={{minHeight: '100vh', padding: "16px"}}>
                <div style={{marginBottom: "16px"}}>
                    <ImportCreateButton importerMenuItem type="custom" />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <ImportIndexMenuItem
                        name="importers"
                        icon="table"
                    />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <ImportIndexMenuItem
                        name="files"
                        icon="file alternate"
                    />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <ImportIndexMenuItem
                        name="docs"
                        icon="book"
                    />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <ImportIndexMenuItem
                        name="demos"
                        icon="video"
                    />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <ImportIndexMenuItem
                        name="database"
                        icon="database"
                        common
                    />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <ImportIndexMenuItem
                        name="connect domain"
                        icon="window maximize outline"
                        common
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(ImportIndexMenu)